export default {
    DATA_ALREADY_SAVED:{
        en:'This Data already Saved.</br>Please Reload your website or Go back',
        bn:'এই ডেটা ইতিমধ্যেই সংরক্ষিত হয়েছে।</br>অনুগ্রহ করে আপনার ওয়েবসাইট পুনরায় লোড করুন অথবা পেছনে যান '
    },
    INPUT_NOT_FOUND:{
        en:'Input Missing.</br>Contact with admin',
        bn:'ইনপুট অনুপস্থিত।</br>অ্যাডমিনের সাথে যোগাযোগ করুন।'
    },
    MOBILE_NUMBER_NOT_SET:{
        en:"Your mobile not is not set.</br>Please Contact with admin",
        bn:"আপনার মোবাইল সেট করা নেই।</br>অ্যাডমিনের সাথে যোগাযোগ করুন।"
    },
    SMS_TOKEN_NOT_SET:{
        en:"Mobile sms system is not set.</br>Please Contact with admin",
        bn:"মোবাইলের এসএমএস সিস্টেম সেট করা নেই।</br>অ্যাডমিনের সাথে যোগাযোগ করুন।"
    },
    DB_SAVE_FAILED:{
        en: 'Fail to save',
        bn: 'সংরক্ষণ করতে ব্যর্থ হয়েছে',
    },
    INPUT_UNCHANGED:{
        en: 'Nothing changed to save',
        bn: 'সংরক্ষণ করার জন্য কিছুই পরিবর্তন করা হয়নি',
    },
    ITEM_NOT_FOUND:{
        en: 'Data not found',
        bn: 'তথ্য পাওয়া যায়নি',
    },
    USER_SESSION_EXPIRED:{
        en: 'Your login session has expired.',
        bn: 'আপনার লগইন সেশনের মেয়াদ শেষ হয়ে গেছে',
    },
}